<template>
  <v-dialog v-model="dialogCreate" persistent max-width="800px">
      <template v-slot:activator="{}">
      </template>
      <v-card>
        <v-card-text>
          <v-container>
            <v-row class="text-right" justify="end">
              <!-- <v-btn class=""><v-icon>mdi-pencil</v-icon></v-btn> -->
              <v-btn
              small
              icon
              color="grey"
              style="background-color: grey"
              @click="dialogCreate = false"
            >
              <v-icon small color="white">mdi-close</v-icon>
            </v-btn>
            </v-row>
            <v-row class="ml-1" justify="start">
              <v-col cols="2" class="ml-1">
                <!-- <h2 class="txt-head" style="margin-top: 1%">ชื่อเครือบริษัท</h2> -->
                <v-avatar size="">
                  <v-img
                    class="img-border"
                    width="100"
                    height="100"
                    :src="require('@/assets/icons/no_user.png')"
                    aspect-ratio="2.7"
                />
                </v-avatar>
              </v-col>
              <v-col cols="3" class="">
                <h2 class="txt-head" style="margin-top: 30%">เพิ่มชื่อเครือบริษัท</h2>
              </v-col>
            </v-row>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
              <!-- NEW -->
              <div class="form-group" v-for="(input,k) in groupCompany" :key="k" style="text-align: center;">
              <v-row class="ml-1" justify="end">
                <v-col cols="10" class="form-control text-left">
                  <p class="txt-font" style="margin-top: -3%">ชื่อเครือภาษไทย</p>
                  <v-text-field
                    v-model="groupCompany[k].groupCompanyNameTh"
                    outlined
                    label="กรอกชื่อเครือภาษาไทย"
                    dense
                    :rules="rulesGroupCompanyNameTh"
                  ></v-text-field>
                </v-col>
                </v-row>
                <v-row class="ml-1" justify="end">
                  <v-col cols="10" class="form-control text-left">
                    <p class="txt-font" style="margin-top: -3%">ชื่อเครือภาษาอังกฤษ</p>
                    <v-text-field
                      v-model="groupCompany[k].groupCompanyNameEng"
                      dense
                      label="กรอกชื่อเครือภาษาอังกฤษ"
                      :rules="rulesGroupCompanyNameEng"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
            </div>
              </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn width="18%" class="ma-0" outlined color="success" dark @click="dialogCreate = false">ยกเลิก</v-btn>
          <v-btn width="18%" class="ma-2 mr-5" color="success" dark @click="submitData()">ตกลง</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
export default {
  components: {
  },
  data () {
    return {
      dialogCreate: false,
      tokenUser: '',
      nameTh: '',
      nameEng: '',
      valid: true,
      groupCompany: [{
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      }],
      tab: null,
      rulesGroupCompanyNameTh: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      rulesGroupCompanyNameEng: [
        v => !!v || 'กรุณากรอก ชื่อเครือบริษัท'
      ],
      items: [
        'เครือ(กรุ๊ปบริษัท)', 'จัดการบริษัท'
      ]
    }
  },
  mounted () {
    EventBus.$on('opendialogcreate', this.openDialogCreate)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
  },
  methods: {
    openDialogCreate () {
      // this.groupCompany.groupCompanyNameTh = item.groupCompanyNameTh
      // this.groupCompany.groupCompanyNameEng = item.groupCompanyNameEng
      // this.idGroupCompany = item._id
      this.dialogCreate = true
    },
    async submitData () {
      // console.log('All Data', this.groupCompany)
      // for (let index = 0; index < this.groupCompany.length; index++) {
      //   if (this.groupCompany[index].groupCompanyNameTh !== '' || this.groupCompany[index].groupCompanyNameEng !== '') {
      //     swal('Success', 'สร้างเครือบริษัท สำเร็จ', 'success')
      //   } else {
      //     swal('Warning', 'สร้างเครือบริษัท No', 'warning')
      //   }
      // }
      var filterValue = this.groupCompany.filter(r => {
        if (r.groupCompanyNameTh === '' || r.groupCompanyNameEng === '') {
          this.$refs.form.validate()
          return r
        }
      })
      // console.log('Filter', filterValue)
      if (filterValue.length !== 0) {
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        await this.axios({
          method: 'post',
          url: `${this.api}/api/vMonk/groupCompany`,
          headers: {
            authorization: this.tokenUser
          },
          data: {
            groupCompany: this.groupCompany
          }
        }).then((response) => {
          // console.log('Get Edit', response.data.result)
          // swal('สำเร็จ', 'สร้างเครือบริษัท สำเร็จ', 'success', {
          //   button: false,
          //   timer: 2000
          // })
          swal({
            title: 'สำเร็จ',
            text: 'สร้างเครือบริษัทเรียบร้อย',
            icon: require('../../../assets/icons/success-icon.png'),
            button: false,
            closeOnClickOutside: false,
            closeOnEsc: false
          })
          this.groupCompanyNameTh = ''
          this.groupCompanyNameEng = ''
          // location.reload()
          // this.$router.push('/managecompany')
          EventBus.$emit('closedialogcreate')
          this.dialogCreate = false
        }).catch(e => {
          console.log(e)
          swal('ผิดพลาด', 'สร้างเครือบริษัท ไม่สำเร็จ!', 'error')
        })
      }
    },
    add () {
      // this.nameTh = ''
      // this.nameEng = ''
      this.groupCompany.push({
        groupCompanyNameTh: '',
        groupCompanyNameEng: ''
      })
      // console.log('Push Company', this.groupCompany)
    },
    remove (index) {
      this.groupCompany.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
</style>
